import { Suspense, useEffect } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ErrorBoundary } from '@common/components';
import { updateParentHash } from '@common/utils/navigationUtils';
import { APP_NAME } from '../../constants';
import * as styles from '../ReportsPage/styles.module.css';

/**
 * Loading fallback component - exported for reuse
 */
export function LoadingFallback() {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.loading}>{t('common.loading')}</div>
      </div>
    </div>
  );
}

/**
 * Layout wrapper that handles:
 * - Parent iframe hash updates
 * - Loading states via Suspense
 * - Error states via ErrorBoundary
 *
 * Breadcrumbs are rendered by each page component individually.
 */
function ReportsLayout() {
  const location = useLocation();

  // Update parent iframe hash when route changes
  useEffect(() => {
    const route = location.pathname;
    updateParentHash(APP_NAME, route || '/', '');
  }, [location.pathname]);

  return (
    <ErrorBoundary key={location.pathname}>
      <Suspense fallback={<LoadingFallback />}>
        <Outlet />
      </Suspense>
    </ErrorBoundary>
  );
}

export default ReportsLayout;
